import { ConfigStatusResponseCode, IdentityProvider, LogoutResponseCode, TokenResponseCode, } from './enums.js';
export const ManagedServiceId = {
    ID_SERVICE: 'ax-id-service',
    MICRO_FRONTEND_SERVICE: 'ax-micro-frontend-service',
    PORTAL_SERVICE: 'ax-portal-service',
    AXAUTH_SERVICE: 'ax-auth-service',
    IMAGE_SERVICE: 'ax-image-service',
    VIDEO_SERVICE: 'ax-video-service',
    USER_SERVICE: 'ax-user-service',
    PERSONALIZATION_SERVICE: 'ax-personalization-service',
    HOSTING_SERVICE: 'ax-hosting-service',
    LOCALIZATION_SERVICE: 'ax-localization-service',
    KEY_SERVICE: 'ax-key-service',
    ENTITLEMENT_SERVICE: 'ax-entitlement-service',
    DRM_SERVICE: 'ax-drm-service',
};
//# sourceMappingURL=types.js.map